import Viewer from "./Viewer"
import Editor from "./Editor"

export default {
    name: "activityFillTheGap",
    title: "Activity Fill The Gap",
    icon: require("./content-icon.svg"),
    category: "training",
    Viewer,
    Editor,
    Preview: Viewer
}